export default "__VITE_ASSET__XWr4dqSS__"